import type React from 'react';
import {
  ReportCardTypes,
  ReportType,
} from '../../../../../core/entities/reports/constants';

type Props = {
  type: ReportType;
};

export const ReportTypeLabel: React.FC<Props> = ({type}) => {
  const getReportTypeColor = (type: ReportType) => {
    if (type === ReportType.SELECTION) {
      return 'bg-category-1';
    }

    if (type === ReportType.ES) {
      return 'bg-category-5';
    }

    return 'bg-category-7';
  };

  return (
    <div
      className={`text-sm text-white rounded-[20px] py-[2px] px-8 ${getReportTypeColor(type)}`}
    >
      {ReportCardTypes[type]}
    </div>
  );
};
